module.exports = __webpack_public_path__ + "img/internet7.ad5d37c6.png";